import { StatusBadge } from '@/components/Common/StatusBadge/StatusBadge';
import { ChevronRight } from '@mui/icons-material';
import { Box } from '@mui/material';
import { SellerOrderItemUi } from './SellerOrdersUi';

export const itemGenerator = (item: SellerOrderItemUi) => {
  return [
    <>
      <Box>{item.orderId}</Box>
    </>,
    <>
      <Box>{item.buyer}</Box>
    </>,
    <>
      <Box>{item.createdAt}</Box>
    </>,
    <>
      <Box>{item.deliveryDate}</Box>
    </>,
    <>
      <Box>{item.badgeStatus && <StatusBadge badge={item.badgeStatus} />}</Box>
    </>,
    <>
      <Box>${item.total}</Box>
    </>,
    <>
      <ChevronRight />
    </>,
  ];
};
